<template>
  <div className="relative w-full h-[300px]">
    <div
      className="absolute top-0 right-2 text-gray-200 animate-bounce text-2xl"
    >
      &#9679;
    </div>
    <div
      className="absolute bottom-1/4 right-1/4 text-gray-200 animate-bounce text-2xl"
    >
      &#9679;
    </div>
    <div
      className="absolute top-1/3 left-10 text-gray-200 animate-bounce text-2xl"
    >
      &#9679;
    </div>

    <div
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    >
      <div className="rounded-xl overflow-hidden relative">
        <div className="rounded-md flex items-center justify-center w-full">
          <div className="blob flex items-center justify-center">
            <v-icon
              :name="icon ?? 'md-lockperson-twotone'"
              class="text-h-primary-50 p-5"
              :scale="17"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ComputerComponent",
  props: { icon: String },
});
</script>

<style lang="scss" scoped>
.blob {
  @apply w-[400px] h-[400px] bg-gradient-to-br from-h-primary-400 to-h-primary-900 shadow-md rounded-full;
  animation: blob 8s infinite ease-in-out;
}
</style>
